import { ColDef } from 'ag-grid-community';
import { renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor } from './../../../../../utils/commonFunctions';

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
  { ...generateImportColumn("", `short_form`), ...importErrorFunction() },
  {
    ...generateImportColumn("Industries", `industries`),

    cellRenderer: (props: any) => {
      return (props.data?.[`industries`]?.toString());
    },
    filterValueGetter: (props: any) => {
      return (props.data?.[`industries`]?.toString());
    },
    ...importErrorFunction(),
  },
  { ...generateImportColumn("Long Form", `long_form`), ...importErrorFunction() },
  {
    ...generateImportColumn("", `description`),
    ...importTextFormatEditor("description"),
    ...importErrorFunction(),

    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return (formatEditor(params?.data?.["description"]));
      }
    },
  },
];
export default columnDefs;
